import React from 'react';
import ReactPlayer from 'react-player';
interface CaseStudyCardProps {
  title: string;
  description: string;
  category: string;
  videoUrl: string;
}
export function CaseStudyCard({
  title,
  description,
  category,
  videoUrl
}: CaseStudyCardProps) {
  return <div className="bg-slate-800/60 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-cyan-500/20 transition-all duration-300 group border border-fuchsia-500/20 hover:border-cyan-500/30" data-id="element-31">
      <div className="relative aspect-video overflow-hidden bg-black" data-id="element-32">
        <ReactPlayer url={videoUrl} width="100%" height="100%" controls light playing={false} className="react-player" data-id="element-33" />
        <div className="absolute top-4 left-4 z-10" data-id="element-34">
          <span className="bg-gradient-to-r from-cyan-500 to-fuchsia-500 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-lg" data-id="element-35">
            {category}
          </span>
        </div>
      </div>
      <div className="p-6 bg-gradient-to-br from-slate-800/80 to-slate-900/80 relative overflow-hidden" data-id="element-36">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-cyan-500/5 to-transparent rounded-full blur-2xl" data-id="element-37"></div>
        <div className="relative" data-id="element-38">
          <h3 className="text-xl font-bold text-white mb-3 leading-tight" data-id="element-39">
            {title}
          </h3>
          <p className="text-cyan-200 font-medium leading-relaxed" data-id="element-40">
            {description}
          </p>
        </div>
      </div>
    </div>;
}